import React from 'react'
import { withTranslation } from 'react-i18next'
import OverviewList from 'pages/Billing/components/OverviewList'

export default withTranslation()(function PrizeSecurityAccountCard({
  t,
  availableBalance = 'GHS 0.00',
  weeklyReserve = 'GHS 0.00',
  monthlyReserve = 'GHS 0.00',
  nextPayoutDate = '--',
  nextPayoutAmount = 'GHS 0.00'
}) {
  const items = [
    { label: t('payout.prize_security.available_balance'), value: availableBalance, valueClassName: 'text-success font-semibold' },
    { label: t('payout.prize_security.weekly_reserve'), value: weeklyReserve },
    { label: t('payout.prize_security.monthly_reserve'), value: monthlyReserve },
    { label: t('payout.prize_security.next_payout_date'), value: nextPayoutDate },
    { label: t('payout.prize_security.next_payout_amount'), value: nextPayoutAmount }
  ]

  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-3">
      <p className="text-sm font-semibold text-dark-blue tracking-wide uppercase">{t('payout.prize_security.title')}</p>
      <OverviewList items={items} />
    </div>
  )
})
